(function () {
  var root = document.querySelector('[data-skip-zero-price-page]');
  if (!root) return;

  var perPage = Number(root.dataset.perPage);
  var currentPage = Number(root.dataset.currentPage);
  var totalPages = Number(root.dataset.totalPages);
  var collectionUrl = root.dataset.collectionUrl;

  if (!perPage || !collectionUrl || currentPage >= totalPages) {
    showEmpty();
    return;
  }

  var params = new URLSearchParams(window.location.search);

  if (hasActiveFilters(params)) {
    goToPage(currentPage + 1);
    return;
  }

  findFirstPricedPage(params)
    .then(function (targetPage) {
      if (!targetPage || targetPage === currentPage || targetPage > totalPages) {
        showEmpty();
        return;
      }
      goToPage(targetPage);
    })
    .catch(function () {
      goToPage(currentPage + 1);
    });

  function hasActiveFilters(searchParams) {
    var keys = Array.from(searchParams.keys());
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].indexOf('filter.') === 0) return true;
    }
    return false;
  }

  function findFirstPricedPage(searchParams) {
    var startIndex = (currentPage - 1) * perPage;
    var jsonPage = Math.floor(startIndex / 250) + 1;
    var seen = (jsonPage - 1) * 250;
    var sortBy = searchParams.get('sort_by');
    var maxJsonPages = Math.ceil((totalPages * perPage) / 250) + 1;

    function readPage() {
      var url = new URL(collectionUrl + '/products.json', window.location.origin);
      url.searchParams.set('limit', '250');
      url.searchParams.set('page', String(jsonPage));
      if (sortBy) url.searchParams.set('sort_by', sortBy);

      return fetch(url.toString())
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load collection products');
          return response.json();
        })
        .then(function (data) {
          var products = data.products || [];
          if (!products.length) return null;

          for (var i = 0; i < products.length; i++) {
            var index = seen + i;
            if (index < startIndex) continue;
            if (lowestPrice(products[i]) > 0) {
              return Math.floor(index / perPage) + 1;
            }
          }

          seen += products.length;
          if (products.length < 250 || jsonPage >= maxJsonPages) return null;
          jsonPage += 1;
          return readPage();
        });
    }

    return readPage();
  }

  function lowestPrice(product) {
    var variants = product.variants || [];
    var lowest = null;
    for (var i = 0; i < variants.length; i++) {
      var price = parseFloat(variants[i].price);
      if (isNaN(price)) continue;
      if (lowest === null || price < lowest) lowest = price;
    }
    return lowest === null ? 0 : lowest;
  }

  function goToPage(page) {
    var nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set('page', String(page));
    window.location.replace(nextUrl.toString());
  }

  function showEmpty() {
    root.classList.add('is-unskippable');
  }
})();
